import styles from './index.scss'
import React from 'react'
import { DpButtonThemeConfig } from '@/libs/components'
import classnames from 'classnames'
import { SusSvg, ErrSvg } from './svgIcon'

export type IDpBusinessCommodityResult = {
  title: string // 标题
  children?: React.ReactNode // 信息内容
  buttonText: string // 按钮文本
  homeBtnText?: string // 返回首页文案
  onClick?: () => void
  onGoHome?: () => void
  customStyle?: object
  isSuccess?: boolean
  color?: string;// 主题色
  buttonStyles?: React.CSSProperties // sass设置的按钮样式
  homeStyles?: React.CSSProperties // sass设置的按钮样式
  isTheme?: Boolean
  footer?: any
  tips?: any
  type?: any
}

const Result = (props: IDpBusinessCommodityResult) => {
  return (
    <div className={styles['dp-business-result']}>
      <header className={styles['dp-business-result-icon']}>
        <div
           className={classnames({
            [styles['dp-business-result-icon-body']]: true,
            [styles[`dp-business-result-icon-body--${props?.type}`]]: props?.type
          })}
        >
          {props?.type !== 'error' ?  <SusSvg /> : <ErrSvg />}
        </div>
      </header>
      <main>
        {
          props?.title &&
            <div className={styles['dp-business-result-title']}>
              {props?.title}
            </div>
        }
        <div className={styles['dp-business-result-body']}>
          {
            props?.tips &&
              <div className={styles['dp-business-result-tips']}>
                {props?.tips}
              </div>
          }
          {props?.children}
          <>
            {
              props?.onClick ?
                <>
                  {props?.children ? <div style={{ height: 16 }}></div> : undefined}
                  <DpButtonThemeConfig
                    buttonText={props?.buttonText || '查看详情'}
                    isTheme={!!props?.isTheme}
                    onClick={props?.onClick}
                    style={{
                      ...props?.buttonStyles,
                      borderWidth: 0,
                      marginTop: 16
                    }}
                    btnProps={{
                      ariaLabel: props?.buttonText || lang['查看详情']
                    }}
                  />
                </>
                : undefined
            }
          </>
         
          {
            props?.onGoHome &&
              <>
                <div style={{ height: 16 }}></div>
                <DpButtonThemeConfig
                  type='dashed'
                  buttonText={props?.homeBtnText || '返回首页'}
                  isTheme={!!props?.isTheme}
                  onClick={props?.onGoHome}
                  style={props?.homeStyles}
                  btnProps={{
                    fill: "outline",
                    ariaLabel: props?.homeBtnText || lang['返回首页']
                  }}
                />
              </>
          }
        </div>
      </main>
      <footer className={styles['dp-business-result-footer']}>
        {props?.footer}
      </footer>
    </div>
  )
}

export default Result
